import { cn } from '@library/component-utils/cn';

export interface MemberDrawerFooterProps {
  children?: React.ReactNode;
  className?: string;
}

export const MemberDrawerFooter = ({
  children = undefined,
  className = ''
}: MemberDrawerFooterProps) => {
  return (
    <div
      className={cn(
        'border-soFresh-140 sticky bottom-0 left-0 flex h-16 w-full items-center justify-end border-t px-6 py-4',
        className
      )}
    >
      {children}
    </div>
  );
};
